// extracted by mini-css-extract-plugin
module.exports = {"btnWhite":"RoundedButton_btnWhite__SCqK0","button":"RoundedButton_button__9wK2V","css-hnovf9":"RoundedButton_css-hnovf9__AIcZt","ant-btn":"RoundedButton_ant-btn__bGCJz"};